import { Button, Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { useOptionalAiAgent } from '@/contexts/AiAgentContext';

export interface HowToButtonProps {
  /** Question sent to the assistant; the current route is sent as page context. */
  question?: string;
}

/** Opens the ERP Assistant with a how-to question about the current screen. */
export function HowToButton({ question = 'How do I use this screen?' }: HowToButtonProps) {
  const ai = useOptionalAiAgent();
  if (!ai) return null;
  return (
    <Tooltip title="How-to guide for this screen">
      <Button
        className="no-print"
        icon={<QuestionCircleOutlined />}
        aria-label="How-to guide for this screen"
        onClick={() => ai.askAssistant(question)}
      />
    </Tooltip>
  );
}
